import { ImageName } from "@mcleod/images";
import { AbstractTableHeadingButton } from "../../AbstractTableHeadingButton";
import { ButtonVariant } from "../../../../button/ButtonVariant";
import { EnabledInTableHeaderValues } from "../../customTools/EnabledInTableHeader";

export class ShareButton extends AbstractTableHeadingButton{
    override create() {
        super.create();
        this.button.setProps({
            id: `${this.table.id}-tools-buttonShare`,
            variant: ButtonVariant.round,
            enabledInTableHeader: EnabledInTableHeaderValues.ONE_ROW_SELECTED,
            imageName: ImageName.share,
            onClick: () => this.showShare(),
            tooltip: "Share the selected row"
        });
    }

    public showShare() {
    }
}
